<template>
	<div
		style="margin: 10px">
      <!-- User info edit dialog -->
      <v-layout justify-center>
        <v-dialog
          :scrollable="true"
          v-model="dialog"
          persistent
          max-width="600px">
          <v-card>
            <v-card-title>
              <span class="headline">User Profile</span>
            </v-card-title>

            <v-card-text>
              <v-container grid-list-md>
                <v-form
                  v-model='validForm'>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-text-field
                        :rules="nameRules"
                        v-model='infoForm.name'
                        label="Name*"
                        required>{{infoForm.name}}</v-text-field>
                    </v-flex>

                    <v-flex xs12>
                      <v-text-field
                        :rules="emailRules"
                        v-model='infoForm.email'
                        label="Email*"
                        readonly
                        required>{{infoForm.email}}</v-text-field>
                    </v-flex>

                    <v-flex xs12>
                      <v-text-field
                        :rules="phoneRules"
                        v-model='infoForm.phone'
                        label="Phone*"
                        required>{{infoForm.phone}}</v-text-field>
                    </v-flex>

                    <v-flex xs12>
                      <v-text-field
                        :rules="faxRules"
                        v-model='infoForm.fax'
                        label="Fax"
                        required>{{infoForm.fax}}</v-text-field>
                    </v-flex>

                    <v-flex xs12>
                      Address
                      <div>
                        <div class="flex mb-4">
                          <div>
                            <v-text-field
                              :rules="streetRules"
                              label="Street"
                              v-model='infoForm.address.street'
                              required>{{infoForm.address.street}}</v-text-field>
                          </div>
                        </div>
                        <v-layout
                          row
                          wrap>
                          <v-flex
                            xs12
                            sm4>
                            <v-text-field
                              :rules="cityRules"
                              label="City"
                              v-model='infoForm.address.city'
                              required>{{infoForm.address.city}}</v-text-field>
                          </v-flex>
                          <v-flex
                            xs12
                            sm4>
                            <v-text-field
                              :rules="stateRules"
                              label="State"
                              v-model='infoForm.address.state'
                              required>{{infoForm.address.state}}</v-text-field>
                          </v-flex>
                          <v-flex
                            xs12
                            sm4>
                            <v-text-field
                              :rules="zipRules"
                              label="Zip Code"
                              v-model='infoForm.address.zip'
                              required>{{infoForm.address.zip}}</v-text-field>
                          </v-flex>
                        </v-layout>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-container>

              <small>*indicates required field</small>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn
                color="primary"
                text
                @click="dialog = false">Close</v-btn>

              <v-btn
                :disabled='!validForm'
                color="primary"
                text
                @click="saveToDB(),dialog = false">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <!-- User info form -->
      <v-card
				color='primary'>
        <v-layout
          column
          fill-height>
          <v-card-title class="white--text pl-5 pt-5">
            <v-spacer>Account Information</v-spacer>

            <v-btn
              @click="openDialog"
              dark
              icon
              class="mr-3">
              <v-icon>edit</v-icon>
            </v-btn>
          </v-card-title>
        </v-layout>

        <v-list two-line>
          <v-list-item>
            <v-list-item-action>
              <v-icon color="primary">mdi-account</v-icon>
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title>{{user.info.name}}</v-list-item-title>
              <v-list-item-subtitle>Name</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-divider inset></v-divider>

          <v-list-item>
            <v-list-item-action>
              <v-icon color="primary">mdi-note</v-icon>
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title>{{planStr}}</v-list-item-title>
              <v-list-item-subtitle>Plan</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-divider inset></v-divider>

          <v-list-item>
            <v-list-item-action>
              <v-icon color="primary">phone</v-icon>
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title>{{user.info.phone}}</v-list-item-title>
              <v-list-item-subtitle>Mobile</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-divider inset></v-divider>

          <v-list-item>
            <v-list-item-action>
              <v-icon color="primary">mdi-fax</v-icon>
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title>{{user.info.fax}}</v-list-item-title>
              <v-list-item-subtitle>Fax</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-divider inset></v-divider>

          <v-list-item>
            <v-list-item-action>
              <v-icon color="primary">mail</v-icon>
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title>{{user.info.email}}</v-list-item-title>
              <v-list-item-subtitle>Email</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-divider inset></v-divider>

          <v-list-item>
            <v-list-item-action>
              <v-icon color="primary">mdi-home-city</v-icon>
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title>{{addrString}}</v-list-item-title>
              <v-list-item-subtitle>Address</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
      <div style='margin: 15px'></div>
      <Beneficiaries/>
      <div style='margin: 15px'></div>
      <AccountManage/>
      <div style='margin: 15px'></div>
	</div>
</template>


<script>
  import { mapFields } from 'vuex-map-fields';
  import { editUserData } from '../helper/firestore';
  import Address from '../components/account/Address';
  import Beneficiaries from '../components/account/Beneficiaries';
  import AccountManage from '../components/account/AccountManage';

  export default {
    data () {
      return {
        dialog: false,
        planStr: '',
        infoForm: {
          name: '',
          email: '',
          phone: '',
          fax: '',
          address: {
            street: '',
            city: '',
            state: '',
            zip: ''
          }
        },
        validForm: false,
        nameRules: [
          v => !!v || 'A name is required'
        ],
        emailRules: [
          v => !!v || 'E-mail is required',
          v => /.+@.+/.test(v) || 'E-mail must be valid'
        ],
        phoneRules: [
          v => !!v || 'A phone number is required',
          v => /^[^A-z]/.test(v) || 'Please enter a valid phone number'
        ],
        faxRules: [
          // v => !!v || 'A fax number is required',
          v => /^$|^[^A-z]/.test(v) || 'Please enter a valid fax number'
        ],
        streetRules: [
          // v => !!v || 'A street address is required'
          v => (!!v || (this.user.info.address.city || this.user.info.address.state || this.user.info.address.zip)) || 'Street name is required for a complete address.'
        ],
        cityRules: [
          // v => !!v || 'A city name is required'
          v => (!!v || (this.user.info.address.street || this.user.info.address.state || this.user.info.address.zip)) || 'City name is required for a complete address.'
        ],
        stateRules: [
          // v => !!v || 'A state is required'
          v => (!!v || (this.user.info.address.city || this.user.info.address.street || this.user.info.address.zip)) || 'State name is required for a complete address.'
        ],
        zipRules: [
          // v => !!v || 'A zip code is required',
          v => /^$|^[0-9]{5}(?:-[0-9]{4})?$/.test(v) || 'Please enter a valid zipcode',
          v => (!!v || (this.user.info.address.city || this.user.info.address.state || this.user.info.address.state)) || 'Zip name is required for a complete address.'
        ],
      }
    },
    mounted() {
      // for users who still have address as string
      if (typeof this.user.info.address === 'string') {
        this.user.info.address = {
          street: '',
          city: '',
          state: '',
          zip: ''
        }
      }
      var plan = this.user.plan.split('_');
      switch (plan[0]) {
        case 'p1':
          this.planStr = 'Plus'
          if (plan[1]) {
            this.planStr += ' Couple'
          }
          break;
        case 'p2':
          this.planStr = 'Complete'
          if (plan[1]) {
            this.planStr += ' Couple'
          }
          break;
        case 'p3':
          this.planStr = 'Concierge'
          if (plan[1]) {
            this.planStr += ' Couple'
          }
          break;
      }
      //making a copy of user info so if you close the dialog it won't update
      this.infoForm = JSON.parse(JSON.stringify(this.user.info));
    },
    methods: {
      openDialog() {
        this.infoForm = JSON.parse(JSON.stringify(this.user.info));
        this.dialog = true
      },
      saveToDB() {
        editUserData(this.user.info, (data) => {
          if (data.status === 200) {
            this.user.info = this.infoForm
            this.snackBarType = "success"
            this.snackBarshow = true
            this.snackBarmessage = "Update complete"
          } else {
            this.snackBarType = "warning"
            this.snackBarshow = true;
            this.snackBarmessage = "Update failed";
          }
        })
      }
    },
    computed: {
      addrString: function () {
      // return this.user.info.address.street + ', ' + this.user.info.address.city + ' ' + this.user.info.address.state + ', ' + this.user.info.address.zip
        let string = '';
        string += this.user.info.address.street;
        this.user.info.address.city ? string += ', ' + this.user.info.address.city : null;
        this.user.info.address.state ? string += ' ' + this.user.info.address.state : null;
        this.user.info.address.zip ? string += ', ' + this.user.info.address.zip : null;

        return string;
      },
      ...mapFields([
        'user',
        'snackBarshow',
        'snackBarType',
        'snackBarmessage',
      ]),
    },
    components: {
      AccountManage,
      Address,
      Beneficiaries
    }
  }
</script>
